import axios from 'axios';
import { SESSION_STORAGE_KEYS } from 'src/utils/constants';

const constructBaseUrl = domain => {
  const stage = process.env.STG;
  if (domain === 'devx') {
    return process.env.STAGE === 'live'
      ? `//api-fabric.chicos.com/v3`
      : `//uat-api-fabric.chicos.com/v3`; // stage env
  }
  return !stage
    ? 'https://api-fabric.chicos.com/ums/v2'
    : `https://uat-api-fabric.chicos.com/ums/v2`;
};

const axiosInstance = () =>
  axios.create({
    responseType: 'json',
    headers: {
      Accept: 'application/json',
    },
  });

const interceptorsRequest = (domainInstance, domain) => {
  domainInstance.interceptors.request.use(function (request) {
    if (domain === 'identityV2') {
      request.baseURL = process.env.NEW_USERS_SELF_API_URL + '/ums/v2';
    } else {
      request.baseURL = constructBaseUrl(domain);
    }
    request.headers.Authorization = `Bearer ${sessionStorage.getItem(
      SESSION_STORAGE_KEYS.ACCESS_TOKEN
    )}`;
    if (domain === 'devx') {
      request.headers['x-fabric-tenant-id'] = sessionStorage.getItem(
        SESSION_STORAGE_KEYS.ACCOUNT_ID
      );
    }
    return request;
  });
};

const domainsAxiosInstances = {
  identity: axiosInstance(),
  devx: axiosInstance(),
  identityV2: axiosInstance(),
};
const { identity, devx, identityV2 } = domainsAxiosInstances;

interceptorsRequest(identity, 'identity');
interceptorsRequest(devx, 'devx');
interceptorsRequest(identityV2, 'identityV2');

export default domainsAxiosInstances;
